import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faTrash } from "@fortawesome/free-solid-svg-icons";
import crudApi from "@serie3/common/api/crudApi";
import UserConfig from "@serie3/mymediaplanner/Modules/User/Resources/Endpoints";

const DeleteAccountPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const [done, setDone] = useState(false);

  const cancel = () => {
    setShow(false);
    navigate("/account");
  };

  const confirm = async () => {
    const response = await crudApi.justGet(UserConfig.endpoints.deleteAccount);
    if (response.ok) {
      setDone(true);
    }
  };

  return (
    <Modal show={show} onHide={cancel} centered backdrop="static">
      <Modal.Header>
        <Modal.Title style={{ fontSize: 16, fontWeight: 700, display: "flex", alignItems: "center", gap: 8, color: "#dc2626" }}>
          <FontAwesomeIcon icon={faTriangleExclamation} />
          {t("Backend.Settings.Tabs.Account.DangerZone", "Danger Zone")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!done ? (
          <>
            <p style={{ fontSize: 14, color: "#374151", marginBottom: 8 }}>
              {t("Backend.Settings.Tabs.Account.ConfirmDelete", "Are you sure you want to delete your account?")}
            </p>
            <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 0 }}>
              {t(
                "Backend.Settings.Tabs.Account.ConfirmDeleteHint",
                "You will receive a confirmation email. Your account is only deleted after clicking the link inside. The account will then be removed after 7 days."
              )}
            </p>
          </>
        ) : (
          <>
            <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 8 }}>
              {t("ProfilePage.CheckMailString", "Please check your email account")}
            </p>
            <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 0 }}>
              {t(
                "Backend.Settings.Tabs.Account.EmailSentHint",
                "Click the link in the email to confirm deletion. Your account will then be scheduled for removal in 7 days."
              )}
            </p>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        {!done ? (
          <>
            <Button variant="secondary" onClick={cancel} style={{ borderRadius: 8, fontSize: 13 }}>
              {t("Common.Discard")}
            </Button>
            <Button variant="danger" onClick={confirm} style={{ borderRadius: 8, fontSize: 13 }}>
              <FontAwesomeIcon icon={faTrash} style={{ marginRight: 6 }} />
              {t("Backend.Settings.Tabs.Account.SendConfirmEmail", "Send confirmation email")}
            </Button>
          </>
        ) : (
          <Button variant="secondary" onClick={cancel} style={{ borderRadius: 8, fontSize: 13 }}>
            {t("Backend.Modal.Closebutton", "Close")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteAccountPage;
